export enum ENV_LIST {
    LOCAL = 'local',
    STAGING = 'staging',
    REVIEW_APP = 'review_app',
    SANDBOX = 'sandbox',
    PRODUCTION = 'production',
}

export enum AvailableToggleFeatures {
    welcome_page = 'welcome_page',
    transport_pricing_enabled = 'transport_pricing_enabled',
    tour_incidents = 'tour_incidents',
    sso_auth = 'sso_auth',
}

const featuresByEnv = Object.freeze({
    // Usage example:
    // [ENV_LIST.LOCAL]: [AvailableToggleFeatures.ma_feature]
    [ENV_LIST.LOCAL]: [
        AvailableToggleFeatures.welcome_page,
        AvailableToggleFeatures.transport_pricing_enabled,
        AvailableToggleFeatures.tour_incidents,
        AvailableToggleFeatures.sso_auth,
    ],
    [ENV_LIST.STAGING]: [
        AvailableToggleFeatures.welcome_page,
        AvailableToggleFeatures.transport_pricing_enabled,
        AvailableToggleFeatures.tour_incidents,
        AvailableToggleFeatures.sso_auth,
    ],
    [ENV_LIST.REVIEW_APP]: [
        AvailableToggleFeatures.welcome_page,
        AvailableToggleFeatures.transport_pricing_enabled,
        AvailableToggleFeatures.tour_incidents,
        AvailableToggleFeatures.sso_auth,
    ],
    [ENV_LIST.SANDBOX]: [
        AvailableToggleFeatures.welcome_page,
        AvailableToggleFeatures.transport_pricing_enabled,
        AvailableToggleFeatures.tour_incidents,
        AvailableToggleFeatures.sso_auth,
    ],
    [ENV_LIST.PRODUCTION]: [
        AvailableToggleFeatures.welcome_page,
        AvailableToggleFeatures.transport_pricing_enabled,
        AvailableToggleFeatures.tour_incidents,
        AvailableToggleFeatures.sso_auth,
    ],
});

export function getEnabledFeaturesByEnv(envName: ENV_LIST) {
    return featuresByEnv?.[envName];
}
